<template>
  <div id="operating_data">
    <h4 class="mb-3 text-uppercase">{{ $t("account.profile.operatingData") }}</h4>

    <label for="company" class="label px-3 text-uppercase">
      {{ $t("account.profile.company") }}{{ profileFieldRequired('company') ? '*' : '' }}
    </label>
    <Field type="text" class="form-control" :placeholder="$t('account.profile.companyLabel')"
      :aria-label="$t('account.profile.company')" aria-describedby="basic-addon1" v-model="models.company" id="company"
      :label="$t('account.profile.company')" :rules="{ required: profileFieldRequired('company') }" name="company" />
    <div>
      <ErrorMessage name="company" class="text-danger text-small text-end m-0 pt-1" />
    </div>

    <label for="streetHouseNr" class="label px-3 text-uppercase">
      {{ $t("account.profile.streetHouseNr") }}{{ profileFieldRequired('street') ? '*' : '' }}
    </label>
    <Field type="text" class="form-control" :placeholder="$t('account.profile.streetHouseNr')"
      :aria-label="$t('account.profile.streetHouseNr')" aria-describedby="basic-addon1" v-model="models.street"
      id="streetHouseNr" :label="$t('account.profile.streetHouseNr')"
      :rules="{ required: profileFieldRequired('street') }" name="streetHouseNr" />
    <div>
      <ErrorMessage name="streetHouseNr" class="text-danger text-small text-end m-0 pt-1" />
    </div>
    <MDBRow>
      <MDBCol col="6">
        <label for="postcode" class="label px-3 text-uppercase">
          {{ $t("account.profile.postcode") }}{{ profileFieldRequired('postal_code') ? '*' : '' }}
        </label>
        <Field type="text" class="form-control" :placeholder="$t('account.profile.postcode')"
          :aria-label="$t('account.profile.postcode')" aria-describedby="basic-addon1" v-model="models.postal_code"
          id="postcode" :label="$t('account.profile.postcode')"
          :rules="{ required: profileFieldRequired('postal_code') }" name="postcode" />
        <div>
          <ErrorMessage name="postcode" class="text-danger text-small text-end m-0 pt-1" />
        </div>
      </MDBCol>
      <MDBCol col="6">
        <label for="location" class="label px-3 text-uppercase">
          {{ $t("account.profile.location") }}{{ profileFieldRequired('city') ? '*' : '' }}
        </label>
        <Field type="text" class="form-control" :placeholder="$t('account.profile.location')"
          :aria-label="$t('account.profile.location')" aria-describedby="basic-addon1" v-model="models.city"
          id="location" :label="$t('account.profile.location')" :rules="{ required: profileFieldRequired('city') }"
          name="location" />
        <div>
          <ErrorMessage name="location" class="text-danger text-small text-end m-0 pt-1" />
        </div>
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol col="12">
        <!-- Country -->
        <template v-if="showProfileField('country')">
          <label for="country" class="label px-3 text-uppercase">
            {{ $t("account.profile.country") }}{{ profileFieldRequired('country') ? '*' : '' }}
          </label>
          <Field type="text" class="form-control" :placeholder="$t('account.profile.country')"
            :aria-label="$t('account.profile.country')" aria-describedby="basic-addon1" v-model="models.country"
            :rules="{ required: profileFieldRequired('country') }" name="country"
            :label="$t('account.profile.country')" />
        </template>
      </MDBCol>
    </MDBRow>
    <MDBRow v-if="showProfileField('countrySelect')">
      <MDBCol col="12">
        <label for="country" class="label px-3 text-uppercase">
          {{ $t("account.profile.country") }}
        </label>
        <select class="form-select" :aria-label="$t('account.profile.country')" id="country" v-model="models.country">
          <option disabled value="">{{ $t("account.profile.choose") }}</option>
          <option :value="country" v-for="(country, index) in me.allowed_shipping_countries" :key="index">
            {{ $t(`account.countries.${country.toLowerCase()}`) }}
          </option>
        </select>
      </MDBCol>
    </MDBRow>
    <MDBRow v-if="showProfileField('language')">
      <MDBCol col="12">
        <label for="sprache" class="from-label">{{
          $t("account.profile.language")
        }}</label>
      </MDBCol>
      <MDBCol col="12">
        <select class="form-select" aria-label="Sprache" id="sprache" v-model="models.lang">
          <option disabled value="">{{ $t("account.profile.choose") }}</option>
          <option value="fe">
            {{ $t("account.profile.french") }}
          </option>
          <option value="it">
            {{ $t("account.profile.italian") }}
          </option>
          <option value="de">
            {{ $t("account.profile.german") }}
          </option>
          <option value="nl">
            {{ $t("account.profile.nederland") }}
          </option>
        </select>
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol col="12" v-if="showProfileField('mobile_phone')">
        <label for="mobile_phone" class="label px-3 text-uppercase">
          {{ $t("account.profile.mobile") }}
        </label>
        <Field type="number" class="form-control" :placeholder="$t('account.profile.mobile_label')"
          :aria-label="$t('account.profile.mobile_label')" aria-describedby="basic-addon1" v-model="models.mobile_phone"
          id="mobile_phone" :label="$t('account.profile.mobile')" name="mobile_phone" />
        <div>
          <ErrorMessage name="mobile_phone" class="text-danger text-small text-end m-0 pt-1" />
        </div>
      </MDBCol>

      <MDBCol col="12" v-if="showProfileField('iban_number')">
        <label for="iban_number" class="label px-3 text-uppercase">
          {{ $t("account.profile.iban_number") }}{{ profileFieldRequired('iban_number') ? '*' : '' }}
        </label>
        <Field type="text" class="form-control" :placeholder="$t('account.profile.iban_number_label')"
          :aria-label="$t('account.profile.iban_number_label')" aria-describedby="basic-addon1"
          v-model="models.iban_number" id="iban_number" :rules="{
            required: profileFieldRequired('iban_number'),
            iban_min_length: true
          }" :label="$t('account.profile.iban_number_label')" name="iban_number" :disabled="hasSavedIban" />
        <div>
          <ErrorMessage name="iban_number" class="text-danger text-small text-end m-0 pt-1" />
        </div>
        <div class="text-muted small">{{ $t("kickbackInfo.withdraw") }}</div>
      </MDBCol>

      <MDBCol col="12" v-if="showProfileField('btw_number')">
        <label for="btw_number" class="label px-3 text-uppercase">
          {{ $t("account.profile.btw_number") }}{{ profileFieldRequired('btw_number') ? '*' : '' }}
        </label>
        <Field type="text" class="form-control" :placeholder="$t('account.profile.btw_number_label')"
          :aria-label="$t('account.profile.btw_number')" aria-describedby="basic-addon1" v-model="models.vat"
          :rules="{ required: profileFieldRequired('btw_number') }" name="btw_number" :disabled="hasSavedVat"
          :label="$t('account.profile.btw_number')" />
        <div>
          <ErrorMessage name="btw_number" class="text-danger text-small text-end m-0 pt-1" />
        </div>
        <div class="text-muted small">{{ $t("kickbackInfo.withdraw") }}</div>
      </MDBCol>
    </MDBRow>
  </div>
</template>

<script setup>
import { Field, ErrorMessage, defineRule, useForm } from "vee-validate";
import { ref, reactive, watch, defineExpose, computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { useProfileFieldShow, useProfileFieldRequired } from "@/composables/useProfileFieldCheck";
import { calculateFieldCompletionPercent } from "@/utils/calculateFieldCompletionPercent";

// Tenant Configuration and Profile Field Check
const { tenantConfig } = useTenantConfig();
const { showProfileField } = useProfileFieldShow(tenantConfig);
const { profileFieldRequired } = useProfileFieldRequired(tenantConfig);
const { t, locale } = useI18n();

defineRule("iban_min_length", (value) => {
  if (!value || String(value).trim() === "") return true;
  const normalizedIban = String(value).replace(/[\s.]+/g, "");
  return normalizedIban.length >= 16
    ? true
    : t("account.profile.iban_min_16_digits");
});

const store = useStore();
const currentLocale = computed(() => store.getters.getCurrentLocale);
const hasSavedIban = ref(false);
const hasSavedVat = computed(() => {
  const profile = store.getters.getProfile;
  if (profile && Object.prototype.hasOwnProperty.call(profile, "vat")) {
    const v = profile.vat;
    return v != null && String(v).trim() !== "";
  }
  const me = store.getters.getMe;
  const v = me?.vat;
  return !!(v && String(v).trim() !== "");
});
const form = useForm();
watch(locale, () => {
  if (form?.validateField && showProfileField('iban_number')) {
    form.validateField('iban_number');
  }
});
const me = computed(() => store.getters.getMe);

const percentageFields = computed(() => {
  const fields = ["company", "street", "country", "city", "postal_code"];
  if (showProfileField("mobile_phone")) {
    fields.push("mobile_phone");
  }
  if (showProfileField("iban_number") && showProfileField("vat")) {
    fields.push("iban_number", "vat");
  }
  return fields;
});

const models = reactive({
  id: null,
  user_id: null,
  company: null,
  street: null,
  postal_code: null,
  city: null,
  country: null,
  lang: currentLocale.value,
  is_main: 1,
  is_residence: 0,
  mobile_phone: null,
  iban_number: null,
  vat: null,
  iban_status: [],
  admin_do_match: false,
});


const percentage = ref(0);

watch(
  [percentageFields, () => ({ ...models })],
  ([fields]) => {
    percentage.value = calculateFieldCompletionPercent(models, fields);
  },
  { immediate: true, deep: true },
);

watch(
  () => store.getters.getMe,
  (newVal) => {
    if (!newVal) return;
    models.country = (newVal.country || "").toUpperCase();
    models.user_id = newVal.id;
    models.lang = newVal.lang;
    models.vat = newVal.vat?.toUpperCase().replace(/\s+/g, "");
  },
  { immediate: true }
);

watch(
  () => store.getters.getUserAddresses,
  (newVal) => {
    const maindAddress = (newVal || []).filter((item) => {
      return item.is_main == 1;
    });


    if (maindAddress.length !== 0) {
      models.id = maindAddress[0].plainId;
      models.city = maindAddress[0].city;
      models.postal_code = maindAddress[0].postal_code;
      models.street = maindAddress[0].street;
    }
  },
  { immediate: true }
);

watch(
  () => store.getters.getProfile,
  (newVal) => {
    if (!newVal) return;
    models.company = newVal.company;
    models.street = newVal.street;
    models.postal_code = newVal.postal_code;
    models.city = newVal.city;
    hasSavedIban.value = false;
    if (showProfileField('mobile_phone')) models.mobile_phone = String(newVal.mobile_phone ?? '');
    if (showProfileField('iban_number')) {
      const iban = newVal.iban_number || "";
      models.iban_number = iban.toUpperCase().replace(/\s+/g, "");
      models.iban_number = models.iban_number.toUpperCase().replace(/\./g, "");
      hasSavedIban.value = models.iban_number.length > 0;
      models.admin_do_match = newVal.admin_do_match;
      models.iban_status = newVal.iban_status;
    }
  },
  { immediate: true }
);


defineExpose({
  models,
  percentage,
});
</script>

<style scoped>
.iban-warning-box {
  background-color: #fff3cd;
  border-left: 4px solid #ffc107;
  border-radius: 0;
  color: #856404;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.5;
}

.iban-warning-text {
  flex: 1;
}
</style>
